module.exports = ".list-item{display:block;color:#e2e2e2 !important;clear:both;cursor:pointer;padding:5px 10px 0px 10px}.list-item::after{content:'';display:block;width:100%;margin-top:5px;border-bottom:1px solid #404040}.list-item .employee-name{font-size:14px}.list-item .icon{font-size:36px !important;color:#9e9e9e}.list-item .secondary{color:#9e9e9e;font-size:11px;padding-right:5px}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/accounting/refunds/accounting-refunds.component.scss
// module id = 869
// module chunks = 0